"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles");

var _avatar = _interopRequireDefault(require("../avatar"));

var _OverlayTrigger = _interopRequireDefault(require("react-bootstrap/es/OverlayTrigger"));

var _Popover = _interopRequireDefault(require("react-bootstrap/es/Popover"));

var _userMenu = _interopRequireDefault(require("./user-menu"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var StyleOverrides,
    UserDropdown,
    boundMethodCheck = function boundMethodCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new Error('Bound instance method accessed before binding');
  }
};

var _default = UserDropdown = function () {
  var UserDropdown =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(UserDropdown, _React$Component);

    function UserDropdown() {
      var _this;

      _classCallCheck(this, UserDropdown);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(UserDropdown).apply(this, arguments));
      _this.togglePopup = _this.togglePopup.bind(_assertThisInitialized(_this));
      _this.state = {
        avatar: null
      };
      return _this;
    }

    _createClass(UserDropdown, [{
      key: "togglePopup",
      value: function togglePopup() {
        var ref;
        boundMethodCheck(this, UserDropdown);

        if (this.state.avatar !== this.avatar) {
          this.setState({
            avatar: this.avatar
          });
        }

        return (ref = this._trigger) != null ? typeof ref.click === "function" ? ref.click() : void 0 : void 0;
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        return _react.default.createElement("div", {
          className: "UserDropdown",
          onClick: this.togglePopup
        }, _react.default.createElement("div", {
          className: "user"
        }, _react.default.createElement(_OverlayTrigger.default, {
          trigger: "click",
          placement: "bottom",
          overlay: this.userMenu(),
          rootClose: true,
          container: this
        }, _react.default.createElement("div", {
          ref: function ref(el) {
            return _this2._trigger = el;
          }
        }, _react.default.createElement(_avatar.default, {
          size: "small",
          user: this.props.user,
          ref: function ref(el) {
            return _this2.avatar = _reactDom.default.findDOMNode(el);
          }
        }))), _react.default.createElement("span", {
          className: "user-name"
        }, this.props.user.first_name)), _react.default.createElement(StyleOverrides, {
          img: this.state.avatar
        }));
      }
    }, {
      key: "userMenu",
      value: function userMenu() {
        var props;
        props = this.props;
        return _react.default.createElement(_Popover.default, {
          id: "user-dropdown-menu"
        }, _react.default.createElement(_userMenu.default, props));
      }
    }]);

    return UserDropdown;
  }(_react.default.Component);

  ;
  UserDropdown.propTypes = {
    user: _propTypes.default.object,
    onNavigate: _propTypes.default.func
  };
  return UserDropdown;
}.call(void 0);

exports.default = _default;

StyleOverrides =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(StyleOverrides, _React$Component2);

  function StyleOverrides() {
    var _this3;

    _classCallCheck(this, StyleOverrides);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(StyleOverrides).apply(this, arguments));
    _this3.handleScroll = _this3.handleScroll.bind(_assertThisInitialized(_this3));
    return _this3;
  }

  _createClass(StyleOverrides, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      return window.addEventListener('scroll', this.handleScroll, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      return window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      boundMethodCheck(this, StyleOverrides);
      return this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var left, ref, ref1, top;

      if (!this.props.img) {
        return null;
      }

      left = (this.props.img.x || ((ref = this.props.img.getBoundingClientRect()) != null ? ref.x : void 0)) + this.props.img.width / 2;
      top = (this.props.img.y || ((ref1 = this.props.img.getBoundingClientRect()) != null ? ref1.y : void 0)) + this.props.img.height;
      return _react.default.createElement("style", null, "#user-dropdown-menu > .arrow { position: fixed; left: ".concat(left, "px !important; top: ").concat(top, "px !important; }"));
    }
  }]);

  return StyleOverrides;
}(_react.default.Component);